// ============================================================
// Unauthorized Page (403)
// ============================================================

import { Box, Typography, Button } from '@mui/material';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { tokens } from '@/theme/tokens';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: tokens.radius.full,
          backgroundColor: `${tokens.colors.warning.main}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ShieldOff size={40} color={tokens.colors.warning.main} />
      </Box>
      <Typography variant="h3" fontWeight={700} sx={{ mb: 1 }}>
        403
      </Typography>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 1 }}>
        Access Denied
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 400 }}
      >
        You don't have permission to access this page. Contact your administrator
        if you believe this is a mistake.
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowLeft size={18} />}
        onClick={() => navigate('/')}
      >
        Back to Dashboard
      </Button>
    </Box>
  );
}
